import { ExtensionAnalytics, AnalyticsEvents } from "./extensionAnalytics";

/**
 * Controller class to connect to the extensionAnalytics object model
 * which contains the logic to send the event and data
 */
class AnalyticsCtrl {
  private extensionAnalytics: ExtensionAnalytics;
  private renderStartTime: number | null;

  constructor() {
    this.extensionAnalytics = new ExtensionAnalytics();
    this.renderStartTime = null;
  }

  public sendAnalytics(event: AnalyticsEvents, properties?: any) {
    const eventInfo = { ...properties };
    switch (event) {
      case "render":
        // Handling render event
        if (properties?.val === "start") {
          // Store the current time if properties are {val:'start'}
          this.renderStartTime = Date.now();
        } else if (
          properties?.val === "success" &&
          this.renderStartTime !== null
        ) {
          // Calculate the time difference and send it if properties are {val:'success'}
          const timeDifference = Date.now() - this.renderStartTime;
          eventInfo.renderTime = timeDifference;
          this.renderStartTime = null; // Reset renderStartTime
        }
        break;
    }
    this.extensionAnalytics.send(event, eventInfo);
  }
}

/**
 * Singleton object of the Analytics controller
 * This will keep track of the same session Id generated
 */
export const analyticsInstance = new AnalyticsCtrl();
